export const comments_4180332 = {"data":{"data":[],"links":{}}}